import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

/*
 * Hilfsklasse welche das laden aller für Angular Material2 Komponenten zur besseren Lesbarkeit aus der app.module.ts auslagert.
 */

@NgModule({
	imports: [
		// BrowserAnimationsModule,
		CommonModule,
		MatButtonModule, MatFormFieldModule, MatInputModule, MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule,
		MatSlideToggleModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatSnackBarModule, MatSidenavModule,
		MatCardModule, MatIconModule, MatListModule, MatGridListModule, MatExpansionModule, MatTableModule, MatSortModule,
		MatPaginatorModule, MatDialogModule, MatCheckboxModule, MatSelectModule, MatChipsModule, MatDatepickerModule, MatNativeDateModule
	],
	exports: [
		CommonModule,
		MatButtonModule, MatFormFieldModule, MatInputModule, MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule,
		MatSlideToggleModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatSnackBarModule, MatSidenavModule,
		MatCardModule, MatIconModule, MatListModule, MatGridListModule, MatExpansionModule, MatTableModule, MatSortModule,
		MatPaginatorModule, MatDialogModule, MatCheckboxModule, MatSelectModule, MatChipsModule, MatDatepickerModule, MatNativeDateModule
	]
})
export class AngularMaterial2Module { }
